import { Sender } from 'xstate';

import asyncCallback from '../../../framework/logic/utils/asyncCallback';
import { LogicContext } from '../types';

import { fetchJackpots } from '../../../model/jackpots';

import { JackpotsQueryType } from '../../../types/jackpotTypes';

import config from '../../../config';

export const watchJackpots = (context: LogicContext) =>
  asyncCallback(
    async (
      callback: Sender<{
        type: 'JACKPOTS_UPDATED';
        data: { jackpots: { [key: string]: any } };
      }>
    ) => {
      let intervalId: ReturnType<typeof setInterval>;

      const { controllersData } = context;
      if (!controllersData.categories) {
        return () => {};
      }
      const { components } = controllersData.categories;
      const jackpotIds = new Set<JackpotsQueryType>();
      components
        .map(([id, entry]) => entry.properties.jackpot_widget?.provider)
        .filter(Boolean)
        .flat()
        .forEach(id => id && jackpotIds.add(id as JackpotsQueryType));

      if (jackpotIds.size > 0 && config.intervals.jackpotsCheck) {
        intervalId = setInterval(async () => {
          const jackpots = await fetchJackpots(
            Array.from(jackpotIds),
            context.user?.currency || config.default_currency
          );

          callback({
            type: 'JACKPOTS_UPDATED',
            data: {
              jackpots,
            },
          });
        }, config.intervals.jackpotsCheck);
      }

      return () => {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
    }
  );
